<template>
    <svg id="LOGO_NETPLUS" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 113.25 44.8">
        <g id="LOGO_COMPLETO" data-name="LOGO COMPLETO">
            <path d="M24.06,44.31H14.35L7.86,21.42v22.89H0V1.35H10.74l5.46,19.59V1.35h7.86V44.31h0Zm42.21,0h-5.29c-3.99,0-6.4-.6-7.18-1.8-.79-1.21-1.18-3.53-1.18-6.96V13.47h-3.95v-5.29h3.95V.91h8.86v7.26h4.79v5.29h-4.79v22.04c0,1.06,.32,1.78,.95,2.15,.63,.37,1.71,.54,3.84,.54v6.12h0Z"/>
            <path d="M46.51,29.58v-3.42c-.07-.16-.08-.37-.12-.55v-.09c-1.27-11.26-13.93-15.7-17.8-14.04-1.35,1.21-2.03,2.92-2.03,5.14v20.85c0,4.9,3.31,7.34,9.93,7.34s10.01-2.35,10.01-7.05v-7.07h-8.53v6.96c0,1.18-.48,1.76-1.43,1.76s-1.45-.58-1.45-1.76v-8.06h11.42Zm-11.42-13.21c0-1.14,.48-1.71,1.45-1.71s1.43,.57,1.43,1.71v7.99h-2.88v-7.99Z"/>
            <path d="M38.43,9.34c-.61-.05-1.26-.07-1.94-.07-.29,0-.56,0-.84,.02,4.09,1.26,8.42,4.52,10.85,8.58v-1.55s0-.02,0-.03c-1.99-3.32-5.08-5.61-8.08-6.94Z"/>
            <path d="M32.66,9.61c-.82,.17-1.57,.4-2.22,.69,5.68-.35,13.64,5,16.07,11.68v-2.23c-2.72-6.44-9.48-9.74-13.84-10.13Z"/>
            <path d="M41.18,9.61c2.54,.55,4.81,2.05,5.41,4.92,0,0-1.14-1.44-2.49-2.68s-2.84-2.24-2.92-2.23Z"/>
            <g>
            <g id="PLUS0">
                <path d="M101.8,18.44h-12.46V6.8h-11.35v11.64h-12.53v10.23h12.54v11.71s11.34,0,11.34,0v-11.71s12.45,0,12.45,0v-10.23Zm-27.71,6.35h-1.05l-.69,1.97h-2.08l2.23-6.33h3.05c1.82,0,2.4,.84,1.95,2.14-.48,1.36-1.6,2.23-3.42,2.23Zm7.63,1.97h-4.93l2.23-6.33h2.08l-1.71,4.86h2.85l-.52,1.48Zm3.88,.17c-1.96,0-2.79-.75-2.03-2.93l1.26-3.57h2.08l-1.34,3.79c-.22,.62-.28,1.16,.57,1.16,.75,0,1.13-.47,1.37-1.16l1.34-3.79h2.08l-1.26,3.58c-.72,2.03-1.97,2.92-4.07,2.92Zm11.18-4.66h-1.97c.05-.22-.03-.35-.14-.43-.13-.08-.3-.11-.5-.11-.46,0-.71,.13-.78,.36-.33,.95,3.52,.36,2.7,2.67-.51,1.47-1.99,2.18-3.73,2.18s-2.42-.98-2.06-2.12h1.99c-.03,.23,.03,.4,.17,.5,.13,.11,.33,.16,.54,.16,.52,0,.92-.17,1.02-.47,.34-.96-3.54-.3-2.68-2.72,.47-1.35,1.87-2.02,3.45-2.02,1.76,0,2.24,.9,2,2.01Z"/>
                <path d="M74.65,21.9h-.59l-.49,1.41h.86c.48,0,.9-.19,1.1-.74,.21-.59-.44-.67-.88-.67Z"/>
            </g>
            <g id="PLUS1">
                <polygon points="109.36 7.44 103.81 7.44 103.81 2.38 98.75 2.38 98.75 7.44 93.16 7.44 93.17 11.88 98.75 11.88 98.75 16.97 103.81 16.97 103.81 11.88 109.36 11.88 109.36 7.44 109.36 7.44"/>
            </g>
            <g id="PLUS2">
                <polygon points="113.25 2.36 110.58 2.36 110.58 0 108.16 0 108.16 2.36 105.48 2.36 105.48 4.43 108.16 4.43 108.16 6.8 110.58 6.8 110.58 4.43 113.25 4.43 113.25 2.36 113.25 2.36"/>
            </g>
            </g>
        </g>
    </svg>
</template>
<script>
export default {
    props: {
        animate: {
            type: Boolean,
            default: false
        }
    },
    data() {
      return {
        timeoutIdLast: null
      }
    },
    methods: {
        handleAnimate() {
            if (this.animate == false) {
                this.timeoutIdLast = localStorage.getItem('loading_variable');
                if (this.timeoutIdLast != null) {
                    this.stopAnimation(this.timeoutIdLast)
                }
            } else {
                this.animatePolygons();
            }
        },
        animatePolygons() {
            const polygons = document.querySelectorAll('#PLUS0, #PLUS1, #PLUS2');
            let index = 0;
            let name = '';
            let timeoutId; 
            if (index == 0) {
                polygons.forEach(polygon => {
                    polygon.style.opacity = 0;
                });
            }

            function showNextPolygon() {
            polygons[index].style.opacity = 1;
            name = polygons[index].id;
            // console.log(name);
            index++;
            if (index < polygons.length) {
                timeoutId = setTimeout(() => {
                polygons[index - 1].style.opacity = 0;
                showNextPolygon();
                }, 500);
                localStorage.setItem('loading_variable', timeoutId);
            } else {
                timeoutId = setTimeout(() => {
                polygons[polygons.length - 1].style.opacity = 0;
                }, 500);
                index = 0;
                showNextPolygon();
            }
            }
            showNextPolygon();
        },
        stopAnimation(timeoutId) {
            clearTimeout(timeoutId);
        }
    },
    watch: {
        animate(newValue, oldValue) {
            this.handleAnimate()
        }
    }
}
</script>
<style scoped>
#LOGO_NETPLUS {
  width: 80%;
}
#PLUS0, #PLUS1, #PLUS2 {
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
}
</style>